<template>
    <div class="task-table-list">
        <el-table ref="taskTable" :data="list" row-key="taskId" @selection-change="handleSelectionChange" @sort-change="handleSortChange" style="width: 100%">
            <el-table-column type="selection" :reserve-selection='true' width="48"></el-table-column>
            <el-table-column :label="$t('project.task_statistics_page_table_column_lable_2')" sortable="custom" column-key="FILENAME" min-width="230" fixed :show-overflow-tooltip="false">
                <template slot-scope="scope">
                    <div class="flex min-w-0 flex-align-center">
                    <div class="file-icon">
                        <svg-icon :name="`ic-${config.FILE_TYPE_MATCH['.' + scope.row.docType] ? config.FILE_TYPE_MATCH['.' + scope.row.docType].icon : ''}`"></svg-icon>
                    </div>
                    <div class="flex-1 text-omission">
                        <el-tooltip placement="top-start" :content="scope.row.taskName">
                            <span>
                                <template v-if="scope.row.status === 'ASSIGNED'">{{ scope.row.taskName }}</template>
                                <template v-else>
                                    <router-link :to="`/workbench/editer?id=${scope.row.docId}&taskId=${scope.row.taskId}`" class="table-link">{{ scope.row.taskName }}</router-link>
                                </template>
                            </span>
                        </el-tooltip>
                    </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column :label="$t('project.task_statistics_page_table_column_lable_3')" prop="taskTypeDesc" width="100"></el-table-column>
            <el-table-column :label="$t('project.task_statistics_page_table_column_lable_4')" width="250" prop="projectName" show-overflow-tooltip></el-table-column>
            <el-table-column :label="$t('project.task_statistics_page_table_column_lable_5')" min-width="110">
                <template slot-scope="scope">
                    <language-direction :source="scope.row.sourceLang" :target="scope.row.targetLang" type="half"></language-direction>
                </template>
            </el-table-column>
            <el-table-column :label="$t('project.task_statistics_page_table_column_lable_6')" min-width="140">
                <template slot-scope="scope">
                    <div class="fonts-12">
                        <template v-if="scope.row.acceptTime">UTC+8 {{ scope.row.acceptTime }}</template>
                        <template v-else>
                            <span class="color-999 fonts-12 text-italic">{{$t('project.task_statistics_page_table_column_tips_label_3')}}</span>
                        </template>
                        <br/>
                        <template v-if="scope.row.submitTime">UTC+8 {{ scope.row.submitTime }}</template>
                        <template v-else>
                            <span class="color-999 text-italic">{{$t('project.task_statistics_page_table_column_tips_label_4')}}</span>
                        </template>
                    </div>
                </template>
            </el-table-column>
            <el-table-column :label="$t('project.task_statistics_page_table_column_lable_7')" prop="taskStatusDesc" min-width="90"></el-table-column>
            <el-table-column :label="$t('project.task_statistics_page_table_column_lable_8')" min-width="90">
                <template slot-scope="scope">
                    {{ scope.row.process }}{{$t('project.task_statistics_page_table_column_tips_label_5')}}
                </template>
            </el-table-column>
            <el-table-column :label="$t('project.task_statistics_page_table_column_lable_9')" prop="taskWords" min-width="90"></el-table-column>
            <!-- <template v-if="customized"> -->
                <el-table-column :label="$t('project.task_statistics_page_table_column_lable_10')" min-width="90">
                    <template slot-scope="scope">
                        {{ scope.row.valuationWords || '-' }}
                    </template>
                </el-table-column>
                <el-table-column :label="$t('project.task_statistics_page_table_column_lable_11')" min-width="90">
                    <template slot-scope="scope">
                       {{ scope.row.price ? `${scope.row.price}/${scope.row.unitDesc}` : '-' }}
                    </template>
                </el-table-column>
                <el-table-column :label="$t('project.task_statistics_page_table_column_lable_13')" min-width="90">
                        <template slot-scope="scope">
                            {{ scope.row.currencyDesc || '-' }}
                        </template>
                    </el-table-column>
                <el-table-column :label="$t('project.task_statistics_page_table_column_lable_12')" prop="" min-width="90">
                    <template slot-scope="scope">
                        {{ scope.row.totalPrice || '-' }}
                    </template>
                </el-table-column>
            <!-- </template> -->
        </el-table>
    </div>
</template>
<script>
import config from '@/utils/config';
import LanguageDirection from '@/components/LanguageDirection';
export default {
    components: {
        LanguageDirection,
    },
    props: {
        list: {
            type: Array,
            default: [],
        },
        customized: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            config
        }
    },
    methods: {
        handleSelectionChange(selection) {
            this.$emit('update', selection)
        },
        handleSortChange({column, prop, order}) {
            console.log(order);
            this.$emit('sort', {sortBy: column.columnKey, sortMode: order === 'ascending' ? 'ASC' : order === 'descending' ? 'DESC' : ''})
        },
        resetTableSelected() {
            this.$refs.taskTable?.clearSelection();
        }
    },
}
</script>
<style lang="scss" scoped>
.task-table-list {
    .table-link {
        color: #000;
        &:hover {
            text-decoration: underline;
        }
    }
    ::v-deep .el-table{
        &::before {
            height: 0;
            width: 0;
            bottom: -10000px;
            background-color: transparent;
        }
        th {
            padding: 10px 0;
            font-size: 14px;
            color: #999999;
        }
        .el-table__row {
            td {
                vertical-align: middle;
                background-color: #ffffff;
                font-size: 14px;
                padding: 10px 0;
                
                .cell {
                    .el-button--text {
                        font-size: 14px;
                        svg {
                            font-size: 18px;
                        }
                    }
                }
            }
            &:hover {
                td {
                    background-color: #fff;
                }
            }
        }
    }
    .task-progress {
        display: inline-block;
        width: 198px;
        position: relative;
        .percentage {
            width: 100%;
            position: absolute;
            top: 0;
            line-height: 20px;
            text-align: center;
            color: #1AC49C;
            font-weight: 500;
        }
    }
    .TO_START {
        color: #FE8E0B;
    }
    .IN_PROGRESS {
        color: #2979FF;
    }
    .COMPLETED,
    .FINISHED {
        color: #00B670;
    }
    .ASSIGNED {
        color: #FF9900;
    }
    .REJECTED {
        color: #999999;
    }
    .rejected {
        color: #F56C6C;
        // background-color: #FDE2E2;
    }
    .progress-text {
        position: absolute;
        top: 0;
        right: 0;
        width: 100%;
        height: 100%;
        font-size: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}
.file-icon {
    display: inline-block;
    height: 32px;
    width: 32px;
    text-align: center;
    line-height: 32px;
    background-color: #F8F8F8;
    border-radius: 50px;
    font-size: 18px;
    margin-right: 12px;
}
</style>
